module.exports = __webpack_public_path__ + "img/empty.d71060da.png";